import { render, staticRenderFns } from "./AnaliticoDePonto.vue?vue&type=template&id=56ce7f78"
import script from "./AnaliticoDePonto.vue?vue&type=script&lang=js"
export * from "./AnaliticoDePonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports